export default class DownloadLink {
    constructor(el) {
      this.el = el;    
      this.init();
      this.initEvents();
    }
  
    init() {
        this.downloadLink = this.el.querySelector(".c-download-link");
    }
  
    initEvents() {
        this.downloadLink?.addEventListener("click", (e) => {
            e.stopPropagation();
            e.preventDefault();
            this.downloadFile(this.downloadLink.dataset.link);
        });
    }

    downloadFile(fileUrl) {
        const fileName = this.downloadLink.dataset.link.replaceAll('\\', '/').split("/").pop();
        fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        });
    }
}
  